import { styled, Box, Button, Typography } from "@mui/material";

export const ShareConfigCodeRoot = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: 15,
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "1fr 1fr",
  },
  [theme.breakpoints.up("lg")]: {
    gridTemplateColumns: "1fr 1fr",
  },
}));

export const CustomButtonShare = styled(Button)(({ theme }) => ({
  color: theme?.palette?.companyColors?.secondary,
  background: theme?.palette?.companyColors?.accent,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: theme?.borderRadius?.small,
  padding: "0.9rem 5rem",
  [theme.breakpoints.up("lg")]: {
    padding: "1rem 1.5rem",
  },
  [theme.breakpoints.up("xl")]: {
    padding: "1.25rem 2rem",
  },
}));

export const ButtonTypography = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  textTransform: "initial",
  fontSize: "1.85rem",
  fontWeight: 400,
  [theme.breakpoints.up("lg")]: {
    fontSize: "1.65rem",
  },
}));
